import api from './api';

// Platform administrator tools.
const adminService = {
  mandateQueue: async () => (await api.get('/admin/mandates')).data,
  mandateDocument: async (propertyId) => (await api.get(`/properties/${propertyId}/mandate/download`, { responseType: 'blob' })).data,
  reviewMandate: async (propertyId, decision, note) =>
    (await api.post(`/properties/${propertyId}/mandate/review`, { decision, note: note || undefined })).data
};

export default adminService;
